import { post , get, getWithHeaders, remove} from './http';
import { catchError } from '../Actions/Error.action';
export const WISHLIST_CHANGE_QUANTITY = 'WISHLIST_CHANGE_QUANTITY';
export const WISHLIST_UPDATE = 'WISHLIST_UPDATE';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const WISHLIST_GET_LISTS = 'WISHLIST_GET_LISTS';
export const WISHLIST_SET_SELECTED = 'WISHLIST_SET_SELECTED';
export const WISHLIST_REMOVE_LISTITEM = 'WISHLIST_REMOVE_LISTITEM';
export const WISHLIST_REMOVE_LIST = 'WISHLIST_REMOVE_LIST';
import { translate } from './translation';

export const load = () => (dispatch) => {
    return getWithHeaders('/api/wishlist/getlists')
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
};

export const loadError = (error) => ({
    type: 'WISHLIST_LOAD_ERROR',
    payload: {
      error,
    },
  });

  export const receive = data => {
    return {
        type: WISHLIST_GET_LISTS,
        payload: {
            lists: data,
        },
    };
};
export const receiveList = (data, listName) => {
    return {
        type: WISHLIST_REMOVE_LISTITEM,
        payload: {
            items: data,
            listName
        },
    };
};


export const setSelected = (selected) => {
    return {
        type: WISHLIST_SET_SELECTED,
        payload: {
            selected
        },
    };
};

export const add = async ({ articleNumber, quantity = 1, listName = null }) => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    const response = await post('/api/wishlist/add', {
        articleNumber,
        quantity: parseInt(quantity),
        ...(listName && { listName })
    });
    return response.json();
};

export const changeQuantity = (articleNumber, quantity, name) => {
    return {
        type: WISHLIST_CHANGE_QUANTITY,
        articleNumber,
        quantity,
        name
    };
};

export const updateWishList = (name) => (dispatch, getState) => {
    console.log(getState().wishLists.lists.find((e) => e.name == name))
    return post('/api/wishlist/update', getState().wishLists.lists.find((e) => e.name == name))
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: translate('wishlist.updatelist.success')
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: false,
                    message: translate('wishlist.general.error'),
                },
            });
        });
};

export const removeListItem = (sortIndex, listName) => (dispatch, getState) => {
    return post('/api/wishlist/remove', {sortIndex, listName})
        .then((response) => response.json())
        .then((result) => {
            dispatch(receiveList(result,listName));
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
       
};
export const removeList = (listName) => (dispatch, getState) => {
    return post('/api/wishlist/delete',  {listName})
        .then((response) =>  response)
        .then((result) => {
            dispatch({
                type: WISHLIST_REMOVE_LIST,
                payload: {
                    listName,
                    message: 'Wishlist was updated successfully',
                    success:true
                },
            });
           
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_REMOVE_LIST,
                payload: {
                    success: false,
                    message: 'There was an error',

                },
            });
        });
       
};

export const addToCart = (name) => (dispatch, getState) => {
    return post('/api/wishlist/addtocart', getState().wishLists.lists.find((e) => e.name == name))
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: true,
                    message:  translate('wishlist.addtocart.success')// 'Wishlist items were added to cart successfully',
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: false,
                    message: translate('wishlist.general.error'),
                },
            });
        });
};